/** @param {string} pathname @param {string} to */
export function isActivePath(pathname, to) {
  if (to === '/') return pathname === '/';
  return pathname === to || pathname.startsWith(`${to}/`);
}

/**
 * The single active nav target: the longest `to` matching the pathname, so that `/zaehler/staende`
 * highlights „Zählerstände“ and not also „Zähler & Versorger“ (`/zaehler`).
 * @param {string} pathname @param {string[]} targets
 */
export function activeNavTarget(pathname, targets) {
  return targets.filter((to) => isActivePath(pathname, to)).sort((a, b) => b.length - a.length)[0] ?? null;
}
